import React from 'react';
import { useDispatch } from 'react-redux';

import { Button } from '@tcc/crate';

import { openLayerInclusionModal } from 'current/uiwidgets';
import { getMessage } from 'util/locale';

type LayerType = 'cci' | 'yield';

const RemoveLayers = ({
  historyRows
}: {
  historyRows: {
    isIncluded: boolean;
    layerType: LayerType;
  }[];
}) => {
  const dispatch = useDispatch();
  const isAnyCCILayerSelected = historyRows.some(({ layerType, isIncluded }) => layerType === 'cci' && isIncluded);
  const isAnyYieldLayerSelected = historyRows.some(({ layerType, isIncluded }) => layerType === 'yield' && isIncluded);

  const removeLayers = (layerTypeToRemove: LayerType) => {
    const layers = historyRows.filter(({ layerType, isIncluded }) => layerType === layerTypeToRemove && isIncluded);

    dispatch(openLayerInclusionModal(layers));
  };

  return (
    <section>
      <Button mode='primary' disabled={!isAnyCCILayerSelected} onClick={() => removeLayers('cci')}>
        {getMessage('button-text__remove-FHI-layers')}
      </Button>
      <Button mode='primary' disabled={!isAnyYieldLayerSelected} onClick={() => removeLayers('yield')}>
        {getMessage('button-text__remove-yield-layers')}
      </Button>
    </section>
  );
};

export default RemoveLayers;
